export default __webpack_public_path__ + "static/assets/abf7d600d75b389482ecd22c05cf58f0.svg";